import { useMutation, useQuery } from "@tanstack/react-query";
import { ApiServiceErr, axiosApi } from "../apiService";

export const useGetProcessData = (salesUnitId?: string | null, productId?: string | null) =>
  useQuery<any, ApiServiceErr>(
    [salesUnitId, productId, "getProcessData"],
    async () => {
      const response = await axiosApi.get(
        `/best-practices/process-gates/${salesUnitId}/${productId}`
      );
      const processData = response.data?.map((c: any) => ({
        key: c.id,
        text: c.processGateName,
        value: c.id
      }));
      return processData;
    },
    {
      cacheTime: 0,
      enabled: !!salesUnitId && !!productId
    }
  );

export const useGetWasteData = (opt?: any) =>
  useMutation<any, ApiServiceErr, any>(async (data: any) => {
    const response = await axiosApi.post(`/best-practices/waste`, data);
    return response.data;
  }, opt);
